import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const tiles = [
  { name: "Audio", note: "Headphones, earbuds, speakers", img: "/img/headphones.jpg", span: "md:col-span-6 lg:col-span-7 lg:row-span-2", dark: true },
  { name: "Beauty", note: "Serums & night rituals", img: "/img/serum.jpg", span: "md:col-span-3 lg:col-span-5" },
  { name: "Home", note: "Tumblers, vases, candles", img: "/img/vase.jpg", span: "md:col-span-3 lg:col-span-5" },
  { name: "Style", note: "Sneakers, shades, bags", img: "/img/sunglasses.jpg", span: "md:col-span-2 lg:col-span-4" },
  { name: "Tech", note: "Wearables", img: "/img/watch.jpg", span: "md:col-span-2 lg:col-span-4" },
  { name: "Fitness", note: "Train & recover", img: "/img/yogamat.jpg", span: "md:col-span-2 lg:col-span-4" },
];

function Tile({ t, i }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
      className={`${t.span} h-[280px] md:h-auto`}
    >
      <Link to={`/shop?category=${t.name}`} className="group relative block h-full overflow-hidden rounded-3xl bg-[var(--ink)]" data-testid={`bento-tile-${t.name.toLowerCase()}`}>
        <img src={t.img} alt={t.name} loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-90 transition-transform duration-[1.2s] ease-out group-hover:scale-[1.07]" />
        <div className="absolute inset-0 bg-gradient-to-t from-[rgba(25,20,35,0.85)] via-[rgba(25,20,35,0.15)] to-transparent" />
        <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-6 text-[var(--bone)] md:p-8">
          <div>
            <p className="eyebrow !text-[10px] text-stone-200">{String(i + 1).padStart(2, "0")} — {t.note}</p>
            <h3 className={`font-display mt-2 ${t.dark ? "text-5xl md:text-7xl" : "text-3xl md:text-4xl"}`}>{t.name}</h3>
          </div>
          <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-[var(--bone)] text-[var(--ink)] transition-[transform,background-color] duration-500 group-hover:rotate-45 group-hover:bg-[var(--terra)] group-hover:text-white"><ArrowUpRight size={20} /></span>
        </div>
      </Link>
    </motion.div>
  );
}

export function Bento() {
  return (
    <section id="categories" className="mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-32" data-testid="bento-section">
      <Reveal className="mb-12 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <p className="eyebrow text-[var(--terra-deep)]">Shop by obsession</p>
          <h2 className="font-display mt-4 max-w-2xl text-4xl leading-[1.02] tracking-tight md:text-6xl">Six aisles. <span className="italic">Zero</span> filler.</h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-[var(--ink-soft)] md:text-base">Every category is trimmed to the products people actually keep buying.</p>
      </Reveal>
      <div className="grid grid-cols-1 gap-4 md:auto-rows-[260px] md:grid-cols-6 lg:auto-rows-[300px] lg:grid-cols-12 lg:gap-6">
        {tiles.map((t, i) => <Tile key={t.name} t={t} i={i} />)}
      </div>
    </section>
  );
}
